import translations from '../translations/fields.translations'

export const FIELD_DEFAULT_MAX_LENGTH = 254

export const FIELD_REPORTED_ERRORS = {
  INVALID: 'invalid',
  UNAUTHORIZED: 'unauthorized',
}

export const ERROR_TRANSLATIONS = {
  postalCode: {
    [FIELD_REPORTED_ERRORS.INVALID]: translations.postalCodeInvalid,
    [FIELD_REPORTED_ERRORS.UNAUTHORIZED]: translations.postalCodeUnauthorized,
  },
}

export const API_VALIDATED_FIELDS = [
  'firstName',
  'firstNamePronunciation',
  'lastName',
  'lastNamePronunciation',
  'company',
  'street',
  'street2',
  'postalCode',
  'city',
  'stateOrProvince',
  'country',
  'phone',
  'countryDialInCode',
]
